import script from "./legoValidatorMixin.vue?vue&type=script&lang=js"
export * from "./legoValidatorMixin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/lego-component/mixins/legoValidator/legoValidatorMixin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "551b36a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('551b36a6', __exports__)) {
    api.reload('551b36a6', __exports__)
  }
  
}


export default __exports__